var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "info-item",
        {
          attrs: {
            isEnabled: _vm.isEnabled,
            label: _vm.resource("DmVisualizer_ChangeInfo_Logo")
          },
          on: {
            "set-enabled": function($event) {
              return _vm.$emit("set-enabled", $event)
            }
          }
        },
        [
          _c("info-file-upload", {
            attrs: { isEnabled: _vm.isEnabled },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }